module.exports = __webpack_public_path__ + "static/media/banner_blackjack-half.2207f044.png";